export const getQuestionListRequest='get entering list async request';
export const getQuestionListSuccess='get entering list async success';
export const getQuestionListFailure='get entering list async failure';





// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/actionType.js